"use client";

import { useEffect } from "react";

const HomeScript = () => {
  useEffect(() => {
    if (typeof window === "undefined") return; // Ensure script runs only on the client

    const searchInput = document.querySelector(".hms-container input") as HTMLInputElement | null;
    const searchWrapper = document.querySelector(".home-media-results-wrapper") as HTMLDivElement | null;
    const homeSearchspinner = document.querySelector(".hm-md-loader") as HTMLDivElement | null;

    if (!searchInput || !searchWrapper || !homeSearchspinner) return;

    const adjustWrapperWidth = () => {
      if (window.innerWidth <= 575) {
        searchWrapper.style.width = "87%";
      } else {
        const inputWidth = searchInput.offsetWidth;
        searchWrapper.style.width = `${inputWidth}px`;
      }
    };

    adjustWrapperWidth();
    window.addEventListener("resize", adjustWrapperWidth);

    searchInput.addEventListener("focus", () => {
      searchWrapper.style.display = "block";
      homeSearchspinner.style.display = "block";
    });

    document.addEventListener("click", (event) => {
      if (!searchWrapper.contains(event.target as Node) && !searchInput.contains(event.target as Node)) {
        searchWrapper.style.display = "none";
        homeSearchspinner.style.display = "none";
      }
    });

    return () => {
      window.removeEventListener("resize", adjustWrapperWidth);
    };
  }, []);

  return null; // No UI needed
};

export default HomeScript;
